import React, { useState, useEffect } from "react";
import Button from "../../../Button/Button";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import { Modal } from "react-bootstrap";
import {
  getAdminListApi,
  getAdminInfoAPI,
  deactivateUserPostApi,
  changePasswordPostApi,
} from "../../../../Api/PanelAdminServices";
import EditCustomerInfo from "../../../Modal/Information/EditCustomerInfo/EditCustomerInfo";
import AdminTable from "../../../Tables/UserPart/UserList/AdminTable/AdminTable";
import AdminInfo from "../../../Modal/Information/AdminInfo/AdminInfo";
import { useHistory } from "react-router-dom";
import Style from "./AdminContainer.module.scss";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import { useForm } from "react-hook-form";
const AdminContainer = () => {
  const [adminList, setAdminList] = useState([]);
  const [rawInfo, setRawInfo] = useState();
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [changePass, setChangePass] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [disable, setDisable] = useState(false);
  const [Info, setInfo] = useState();
  const [userId, setUserId] = useState();
  useEffect(() => {
    getSupplierList();
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const getSupplierList = async () => {
    getAdminListApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setAdminList(res.admin);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  let history = useHistory();

  const showAddress = async (id, info) => {
    getAdminInfoAPI(info.userId, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setInfo(res.info);
          /////Edit///////
          if (id === 2) {
            setEditVisible(true);
            history.push(`/editadmininfo/${info.userId}`, res.info);
          }
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
    setUserId(info.userId);
    setRawInfo(info);
    ////info/////
    if (id === 1) {
      setUserInfo(true);
    }

    //////Delete///////
    if (id === 3) {
      setDeleteVisible(true);
    }

    ////// change password ///////
    if (id === 4) {
      setChangePass(true);
    }
  };

  const handleOkAddress = () => {
    setDeleteVisible(false);
    setEditVisible(false);
    setUserInfo(false);
    setChangePass(false);
  };
  const data =
    adminList &&
    adminList.map((item, index) => {
      return {
        key: index,
        fName: item.first_name + " " + item.last_name,
        lName: item.last_name,
        phone: item.phone,
        signUpDate: item.register_date,
        userId: item.id,
        status: item.status,
      };
    });
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };

  const onsubmit = (data) => {
    const info = {
      password: data.oldPass,
      new_password: data.newPass,
    };
    changePasswordPostApi(info, (res) => {
      if (res.status === 0) {
        errorToast(res.message);
      } else {
        succToast("با موفقیت ویرایش شد");
      }
      console.log(res);
    });
  };

  const deactiveCustomer = () => {
    setDisable(true);
    let info = {
      id: userId,
      status: rawInfo.status === "0" ? "1" : "0",
      type: "admin",
    };
    deactivateUserPostApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت انجام شد");
        setDisable(false);
        setDeleteVisible(false);
      } else {
        errorToast("مشکلی پیش آمد");
        setDisable(false);
        setDeleteVisible(false);
      }
    });
    getSupplierList();
  };

  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از غیرفعال کردن کاربر موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deactiveCustomer}
              disabledProps={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={userInfo} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات تامین کننده</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminInfo
            address={""}
            showAddress={false}
            Info={Info}
            handleOk={handleOkAddress}
          />
        </Modal.Body>
      </Modal>

      <Modal show={editVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>ویرایش اطلاعات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditCustomerInfo
            rawInfo={rawInfo}
            handleOkAddress={handleOkAddress}
          />
        </Modal.Body>
      </Modal>

      <Modal show={changePass} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>تغییر رمز عبور</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onsubmit)} className={Style.changePass}>
            <label className={Style.passText}>رمز عبور فعلی</label>
            <input
              {...register("oldPass", { required: true })}
              className={errors.oldPass ? Style.errorInput : Style.pass}
            />
            <label className={Style.passText}>رمز عبور جدید</label>
            <input
              {...register("newPass", { required: true })}
              className={errors.newPass ? Style.errorInput : Style.pass}
            />
            <div className={Style.btnHolder}>
              <button className={Style.changeBtn}>تغییر</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <TableFixedPage title="لیست ادمین" />
      <AdminTable showAddress={showAddress} data={data} />
    </div>
  );
};

export default AdminContainer;
